// extracted by mini-css-extract-plugin
export default {"container":"_p-z","ratingLayout":"aq-z","ratingLabel":"bq-z","nonInteractiveRatingLabel":"cq-z"};